import ErrorBoundary from '@/components/Error/ErrorBoundary/ErrorBoundary';
import { CommonError } from '@/components/Error/CommonError/CommonError';
import { DashboardView } from '@/views/DashboardView/DashboardView';
import { useModalAsSingleViewedBanner } from '@/hooks/useModalAsSingleViewedBanner';
import { ELocalStorage } from '@/types/storage';
import { SimpleModalInfo } from '@/components/Modal/components/SimpleModalInfo/SimpleModalInfo';

export const DashboardPage = () => {
  const { ModalToRender: CircleAddedToStablecoinsModalToRender } = useModalAsSingleViewedBanner({
    ModalContent: SimpleModalInfo,
    localStorageKey: ELocalStorage.CIRCLE_ADDED,
  });

  return (
    <>
      <ErrorBoundary fallback={<CommonError variant="reload" />}>
        <DashboardView />
      </ErrorBoundary>

      <CircleAddedToStablecoinsModalToRender />
    </>
  );
};
